import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import classnames from "classnames";
import Image from "react-bootstrap/Image";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
import { IconReusableComponent } from "../../reusableComponents/iconSearchReusableComponent/IconReusableComponent";
import {
  InputBoxComponent,
  TextAreaReusableComponent,
} from "../../reusableComponents/inputReusableComponent/InputBoxComponent";
import BottomNavigationMobile from "../navigationSection/BottomNavigationMobile";
import { TopNavigationBarMobile } from "../navigationSection/TopNavigationBarMobile";
// import { AmealioLoader } from "../../Loader/AmealioLoader";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../store/actions/errorActions";
import isEmpty from "../../../store/validation/is-Empty";
import VendorChangePassword from "./VendorChangePassword";
import Media from "react-media";

export class EditProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disabled: false,
      userName: "",
      restaurantName: "",
      phoneNumber: "",
      address: "",
      hasSetEditProps: false,
      loader: false,
      errors: {},
    };
  }

  async componentDidMount() {
    if (this.props.onboarding._id) {
      this.setState({
        userName: !isEmpty(this.props.onboarding.point_of_contact[0].firstName)
          ? this.props.onboarding.point_of_contact[0].firstName +
            " " +
            this.props.onboarding.point_of_contact[0].lastName
          : "",
        restaurantName: !isEmpty(this.props.onboarding.restaurant_name)
          ? this.props.onboarding.restaurant_name
          : "",
        phoneNumber: !isEmpty(this.props.onboarding.vendorNumber)
          ? this.props.onboarding.vendorNumber
          : "",
        address: !isEmpty(this.props.onboarding.restaurant_address)
          ? this.props.onboarding.restaurant_address
          : "",
        hasSetEditProps: true,
      });
    }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (!isEmpty(nextProps.onboarding._id)) {
      return {
        userName: !isEmpty(nextProps.onboarding.point_of_contact[0].firstName)
          ? nextProps.onboarding.point_of_contact[0].firstName +
            " " +
            nextProps.onboarding.point_of_contact[0].lastName
          : "",
        restaurantName: !isEmpty(nextProps.onboarding.restaurant_name)
          ? nextProps.onboarding.restaurant_name
          : "",
        phoneNumber: !isEmpty(nextProps.onboarding.vendorNumber)
          ? nextProps.onboarding.vendorNumber
          : "",
        address: !isEmpty(nextProps.onboarding.restaurant_address)
          ? nextProps.onboarding.restaurant_address
          : "",
        hasSetEditProps: true,
      };
    }
    if (nextProps.auth.loader !== nextState.loader) {
      return {
        loader: nextProps.auth.loader,
      };
    }
    if (nextProps.errors !== nextState.errors) {
      return {
        errors: nextProps.errors,
      };
    }
    return null;
  }

  onClickDisabled = (e) => {
    this.setState({
      disabled: !this.state.disabled,
    });
  };

  /**************************
   * @DESC - ONCHANGE HANDLER
   ***************************/
  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  render() {
    // if (this.state.loader) {
    //   return (
    //     <React.Fragment>
    //       <AmealioLoader />
    //     </React.Fragment>
    //   );
    // }
    const { errors, disabled } = this.state;
    return (
      <React.Fragment>
        <Container fluid>
          <Row>
            <div className="left-side-panel">
              <LeftSideNavigation />
            </div>
            <div className="top-panel">
              <TopNavigationBarMobile
                displayLeft="backButton"
                backLink="/seatingdashboard"
                displayRight={false}
                headText="Profile"
              />
            </div>
            <div className="right-side-panel">
              <RightSideNavigation />
              <div className="new-edit-profile-button">
                <IconReusableComponent
                  iconImage={require("../../../assets/images/ActionImages/editwhite.png")}
                  iconImageAlt="Edit Icon"
                  iconImageTitle="Edit Profile"
                  iconText="Edit Profile"
                  display={false}
                />
              </div>
              <div id="style-4" className="main-edit-screen">
                <div>
                  <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-5 d-flex justify-content-center">
                      <div className="main-edit-section-width">
                        <div className="col-12 d-flex justify-content-center align-items-center">
                          <div className="image-display-box">
                            <Image
                              fluid
                              src={require("../../../assets/images/ActionImages/demoprofile.jpg")}
                              alt="profile"
                              title="Profile Image"
                              roundedCircle
                            />
                          </div>
                          <div className="camera-button">
                            <Image
                              fluid
                              src={require("../../../assets/images/ActionImages/camera.svg")}
                              alt="Camera"
                              title="Upload Profile"
                              className="camera-image"
                            />
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="edit-button">
                            <Image
                              fluid
                              src={require("../../../assets/images/ActionImages/edit.png")}
                              alt="edit"
                              title="Edit Profile"
                              className="edit-image"
                              style={{ cursor: "pointer" }}
                              onClick={this.onClickDisabled}
                            />
                            <p>Edit Profile</p>
                          </div>
                        </div>
                        <div className="col-12">
                          <Form noValidate onSubmit={this.handleSubmit}>
                            <Form.Row className="input-component-insideRow align-items-center">
                              <div className="col-2 col-sm-2 col-md-1 col-lg-1 col-xl-1">
                                <Image
                                  src={require("../../../assets/images/ActionImages/user.svg")}
                                  alt="user pic"
                                  fluid
                                  className="icon-input"
                                />
                              </div>
                              <div className="col-10 col-sm-10 col-md-11 col-lg-11 col-xl-11 ">
                                <InputBoxComponent
                                  displayLabel={true}
                                  controlId="Name"
                                  labelText="Name"
                                  inputType="text"
                                  placeHolder="Enter Name"
                                  name="userName"
                                  onChange={this.onChange}
                                  value={this.state.userName}
                                  required="required"
                                  showBottom={true}
                                  error={errors.userName}
                                  inputClassName={
                                    disabled === false
                                      ? "disable-input-button-css"
                                      : classnames(
                                          "input-component-inputfield",
                                          {
                                            invalid: errors.userName,
                                          }
                                        )
                                  }
                                  disabled={disabled === true ? false : true}
                                />
                              </div>
                              <div className="col-12">
                                {disabled === false ? (
                                  <hr className="mt-0" />
                                ) : (
                                  <hr />
                                )}
                              </div>
                              <div className="col-2 col-sm-2 col-md-1 col-lg-1 col-xl-1"></div>
                              <div className="col-10 col-sm-10 col-md-11 col-lg-11 col-xl-11">
                                <InputBoxComponent
                                  displayLabel={true}
                                  controlId="Restaurant Name"
                                  labelText="Name of the Restaurant"
                                  inputType="text"
                                  placeHolder="Enter Restaurant Name"
                                  name="restaurantName"
                                  onChange={this.onChange}
                                  value={this.state.restaurantName}
                                  required="required"
                                  showBottom={true}
                                  error={errors.restaurantName}
                                  inputClassName={
                                    disabled === false
                                      ? "disable-input-button-css"
                                      : classnames(
                                          "input-component-inputfield",
                                          {
                                            invalid: errors.restaurantName,
                                          }
                                        )
                                  }
                                  disabled={disabled === true ? false : true}
                                />
                              </div>
                              <div className="col-2 col-sm-2 col-md-1 col-lg-1 col-xl-1">
                                <Image
                                  src={require("../../../assets/images/ActionImages/phone.svg")}
                                  alt="user pic"
                                  fluid
                                  className="icon-input"
                                />
                              </div>
                              <div className="col-10 col-sm-10 col-md-11 col-lg-11 col-xl-11">
                                <InputBoxComponent
                                  displayLabel={true}
                                  controlId="phoneNumber"
                                  labelText="Phone No"
                                  inputType="text"
                                  placeHolder="Enter Number"
                                  name="Phone No"
                                  onChange={this.onChange}
                                  value={this.state.phoneNumber}
                                  required="required"
                                  showBottom={true}
                                  error={errors.phoneNumber}
                                  inputClassName={
                                    disabled === false
                                      ? "disable-input-button-css"
                                      : classnames(
                                          "input-component-inputfield",
                                          {
                                            invalid: errors.phoneNumber,
                                          }
                                        )
                                  }
                                  disabled={disabled === true ? false : true}
                                />
                              </div>
                              <div className="col-12">
                                {disabled === false ? (
                                  <hr className="mt-0" />
                                ) : (
                                  <hr />
                                )}
                              </div>
                              <div className="col-2 col-sm-2 col-md-1 col-lg-1 col-xl-1">
                                <Image
                                  src={require("../../../assets/images/ActionImages/maps-and-flags.svg")}
                                  alt="user pic"
                                  fluid
                                  className="icon-input"
                                />
                              </div>
                              <div className="col-10 col-sm-10 col-md-11 col-lg-11 col-xl-11">
                                <TextAreaReusableComponent
                                  controlId="addressTextArea"
                                  displayText={true}
                                  labelText="Address"
                                  labelTextClass=""
                                  placeholder="25Th Wedding Anniversary"
                                  rows="3"
                                  onChange={this.onChange}
                                  name="address"
                                  value={this.state.address}
                                  inputClassName={
                                    disabled === false
                                      ? "disable-input-button-css"
                                      : classnames("input-text-area", {
                                          invalid: errors.address,
                                        })
                                  }
                                  disabled={disabled === true ? false : true}
                                  error={errors.address}
                                />
                              </div>
                              <div className="col-12">
                                {disabled === false ? (
                                  <hr className="mt-0" />
                                ) : (
                                  <hr />
                                )}
                              </div>
                            </Form.Row>
                          </Form>
                          <div className="p-0 col-12 text-right mb-5">
                            <VendorChangePassword />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7"></div>
                  </div>
                </div>
              </div>
            </div>
            <Media query="(max-width: 991px)">
              <div className="bottom-panel">
                <BottomNavigationMobile />
              </div>
            </Media>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

EditProfile.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  onboarding: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
});

export default connect(mapStateToProps, {
  clear_all_errors,
})(withRouter(EditProfile));
